export default __webpack_public_path__ + "static/media/brakes.794a06f8.svg";